import type { TileImage, Variation, VariationV2 } from '@shared/types/types.ts';
import type { ProductLink } from '@tile/components/product-title/ProductLink';
import type { ProductTitle } from '@tile/components/product-title/ProductTitle.ts';
import { mapTitle } from '@tilelist/layouts/mapping/ProductTitle.ts';
import { mapLink } from '../mapping/ProductLink';

export type DefaultLayout = {
    /**
 *
 */
    readonly variation: Variation | VariationV2;

    /**
 *
 */
    readonly title: ProductTitle;

    readonly link: ProductLink;

    readonly images: TileImage[];
};

/**
 *
 */
export function createDefaultLayout(variation: Variation | VariationV2, showTopInfos: boolean): DefaultLayout {
    const patchedVariation: Variation | VariationV2 = {
        ...variation,
        topInfos: showTopInfos && variation.topInfos?.length ? variation.topInfos : undefined,
    };
    return {
        variation: patchedVariation,
        title: mapTitle(variation, showTopInfos && !!variation.topInfos?.length),
        link: mapLink(variation),
        images: getImages(variation),
    };
}

function getImages(variation: Variation | VariationV2): TileImage[] {
    return 'images' in variation ? variation.images.slice(0, 3) : [variation.image];
}
